import styled from 'styled-components';

export const Wrapper = styled.div<{ $isIframe: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.main};
	padding-bottom: 24px;
	min-height: 100%;
	padding-top: ${({ $isIframe }) => ($isIframe ? '56px' : '0')};
`;

export const FakeHeader = styled.div`
	background-color: ${({ theme }) => theme.colors.background.main};
	height: 56px;
	width: 100%;
	position: relative;
	z-index: 1;
`;

export const FakeHeaderBody = styled.div`
	max-width: 1760px;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 20px;
	height: 100%;

	a {
		display: inline-flex;
	}

	svg {
		height: 44px;
		fill: ${({ theme }) => theme.colors.control.primary};
	}

	img {
		height: 24px;
	}
`;

export const Container = styled.div<{ $isFullScreen: boolean }>`
	margin: ${({ $isFullScreen }) => ($isFullScreen ? '0 auto' : '20px auto 0')};
	width: 100%;
	padding: ${({ $isFullScreen }) => ($isFullScreen ? '0' : '0 20px')};
	max-width: ${({ $isFullScreen }) => ($isFullScreen ? '100%' : '1760px')};

	@media (max-width: 1800px) {
		max-width: ${({ $isFullScreen }) => ($isFullScreen ? '100%' : '1480px')};
	}
`;
